import * as React from 'react'
import { ReactElement } from 'react'
import { SpinButton } from '@fluentui/react-components'
import { LegalAidCertificateDto } from './LegalAidCertificateForm'
import { useFormikContext } from 'formik'
import { formatCurrencyDecimals, formatNumber, parseNumber } from '../../../helpers/numberHelper'
import { Currency } from '../../../config/i18nConfig'
import PinnerInputField from './PinnerInputField'
import { LegalAidCertificatePanelProps } from './FormContainer'

type Props = Pick<LegalAidCertificatePanelProps, 'styles'> & {
    fieldName: keyof Pick<LegalAidCertificateDto, 'baseHours' | 'travelHours'>
    pinnedFieldName: keyof Pick<LegalAidCertificateDto, 'baseFee' | 'travelFee'>
    rate: string
    currency: Currency
    disabled: boolean
}

export default function LegalAidHourInput({ styles, fieldName, pinnedFieldName, rate, currency, disabled }: Props): ReactElement {
    const {
        values: { [fieldName]: value },
        setFieldValue,
    } = useFormikContext<LegalAidCertificateDto>()
    const parsedValue = parseNumber(value, 'en')

    return (
        <PinnerInputField
            fieldName={fieldName}
            pinnedFieldName={pinnedFieldName}
            getPinnedValue={() => formatCurrencyDecimals(parsedValue * parseNumber(rate, 'en'), currency, 'en', 'en', false)}
        >
            <SpinButton
                disabled={disabled}
                placeholder="Punten"
                className={styles.input}
                precision={2}
                min={0}
                max={99}
                value={parsedValue}
                onChange={(_, data) => {
                    // Set a timeout to push the onChange() to the end of the event queue, so the onBlur() event in the
                    // pinned field will run first.
                    setTimeout(() => {
                        setFieldValue(
                            fieldName,
                            formatNumber(data.value || parseNumber(data.displayValue?.replace(',', '.') || 0, 'en'), '0.00', 'en'),
                        )
                    }, 0)
                }}
                onFocus={event => event.target.select()}
                displayValue={formatNumber(value, '0.00')}
            />
        </PinnerInputField>
    )
}
